import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Flex, Heading, Box, UnorderedList, ListItem } from "@chakra-ui/react"

const styles = {
  root: {
    bg: "#E8EBFE",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    px: "24px",
    pb: "32px",
  },
  "heading-box": {
    margin: { base: "0px", md: "0x", lg: "0 auto" },
  },
  heading: {
    fontWeight: "bold",
    fontSize: { base: "24px", md: "24px", lg: "40px" },
    textAlign: { base: "left", md: "left", lg: "center" },
    lineHeight: { base: "32px", md: "32px", lg: "48px" },
    my: { base: "24px", md: "24px", lg: "32px" },
  },
  "inner-box": {
    flexDirection: { base: "column-reverse", md: "column-reverse", lg: "row" },
    alignItems: { base: "center", md: "center", lg: "flex-start" },
    justifyContent: "space-between",
  },

  "left-box": {
    width: { base: "100%", md: "100%", lg: "642px" },
    mt: { base: "24px", md: "24px", lg: "0px" },
  },

  text: {
    fontSize: "16px",
    color: "#041424",
    lineHeight: "24px",
    letterSpacing: "0.024px",
  },

  image: {
    height: { base: "100%", md: "100%", lg: "469px" },
    width: { base: "100%", md: "100%", lg: "326px" },
  },
}

const SectionConferences = () => (
  <Flex sx={styles.root}>
    <Box sx={styles["heading-box"]}>
      <Heading sx={styles.heading}>
        Conference Submissions and Presentations
      </Heading>
    </Box>
    <Flex sx={styles["inner-box"]}>
      <Box sx={styles["left-box"]}>
        <UnorderedList>
          <ListItem sx={styles.text}>
            Hospital Readmissions After Total Joint Arthroplasties
          </ListItem>
          <ListItem sx={styles.text}>
            Female Surgeon Presence in Joint Arthroplasties
          </ListItem>
          <ListItem sx={styles.text}>
            Incidence of Revision Joint Arthroplasties
          </ListItem>
          <ListItem sx={styles.text}>
            Leveraging TDABC to Improve Hospital Profitability
          </ListItem>
          <ListItem sx={styles.text}>
            Cost and Efficiency Improvement in Rotator Cuff Repair
          </ListItem>
          <ListItem sx={styles.text}>
            Digital Solutions for TDABC in Orthopedic Surgery
          </ListItem>
          <ListItem sx={styles.text}>
            Surgeon Volume and Patient Outcomes in Shoulder Arthroplasty
          </ListItem>
          <ListItem sx={styles.text}>
            Trends in Outpatient Shoulder Arthroplasties in the United States
          </ListItem>
          <ListItem sx={styles.text}>
            Trends in Patient Risk in Outpatient Joint Arthroplasties
          </ListItem>
          <ListItem sx={styles.text}>
            Costs of Hip Arthroscopy and Associated Drivers
          </ListItem>
          <ListItem sx={styles.text}>
            Racial disparity in Total Joint Arthroplasty
          </ListItem>

          <ListItem sx={styles.text}>
            Applications of Generative Artificial Intelligence in Orthopedic
            Surgery
          </ListItem>
          <ListItem sx={styles.text}>
            Gain-Sharing Arrangements Between Hospital and Orthopedic Surgeons
          </ListItem>
        </UnorderedList>
      </Box>
      <StaticImage
        src="../../images/vbhc/vbhc-confrences.png"
        alt="Image of a person showing graph chart to a group of others with against a background of gears and magnifying glasses."
        sx={styles.image}
      />
    </Flex>
  </Flex>
)

export default SectionConferences
